"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddListTableItem = exports.AddListTableBody = exports.AddListTableHeader = exports.AddListTableRow = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AddListTable = require("./AddListTable.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 可增加列表的Table
 */
var AddListTable = function AddListTable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTable, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalContentList"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalTable"
  }, children)));
};

var _default = AddListTable;
exports.default = _default;
AddListTable.propTypes = {
  children: _propTypes.default.any
};

var AddListTableRow = function AddListTableRow(_ref2) {
  var children = _ref2.children,
      isadmin = _ref2.isadmin;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableRow, {
    isadmin: isadmin
  }, children);
};

exports.AddListTableRow = AddListTableRow;
AddListTableRow.propTypes = {
  children: _propTypes.default.any,
  isadmin: _propTypes.default.bool
};

var AddListTableHeader = function AddListTableHeader(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableHeader, null, children);
};

exports.AddListTableHeader = AddListTableHeader;
AddListTableHeader.propTypes = {
  children: _propTypes.default.any
};

var AddListTableBody = function AddListTableBody(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableBody, null, children);
};

exports.AddListTableBody = AddListTableBody;
AddListTableBody.propTypes = {
  children: _propTypes.default.any
};

var AddListTableItem = function AddListTableItem(_ref5) {
  var children = _ref5.children,
      flex = _ref5.flex;
  return /*#__PURE__*/_react.default.createElement(_AddListTable.UiAddListTableItem, {
    flex: flex
  }, children);
};

exports.AddListTableItem = AddListTableItem;
AddListTableItem.propTypes = {
  children: _propTypes.default.any,
  flex: _propTypes.default.number
};